/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const cityDataSchema = z.object({
	id: z.string(),
	name: z.string(),
	radius: z.number(),
	region: z.object({ id: z.string(), name: z.string() }).nullable(),
	country: z.object({ id: z.string(), name: z.string() }).nullable(),
})

export type CityDataSchema = z.infer<typeof cityDataSchema>
